<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">标准方案列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="10">
          <el-button type="primary" size="small" @click="addProgram()" plain><i class="fa fa-plus"></i> 添加标准方案</el-button>
        </el-col>
        <el-col :span="8" offset="6">
          <el-input size="small" type="text" placeholder="请方案名称" clearable v-model="searchFm.name">
            <el-button slot="append" size="small" @click="doSearch" type="primary"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table class="list-table" :data="programList" border :stripe="true" style="width: 100%" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="240"></el-table-column>
        <el-table-column prop="intro" label="描述" :formatter="sliceIntro"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="addProgram(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="remove(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>


    <program-save :visible="addDialog" :echo-id="echoId" @done="saveFinish"></program-save>
  </div>
</template>

<script>
  import {getProgramList, deleteProgram} from '@/api/manage/program'
  import PageBar from '@/components/PageBar.vue'
  import ProgramSave from './ProgramSave'
  import {handleConfirm} from '@/utils/confirm'

  export default {
    components: {
      PageBar, ProgramSave
    },
    data() {
      return {
        echoId:null,
        addDialog: false,
        programList: [],
        searchFm: {},
        page: {
          pageNo: 1,
          pageSize: 20
        }
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      fetchData() {
        let {pageNo,pageSize,param} = this.page
        getProgramList('standard',{pageNo,pageSize,param}).then(res => {
          this.page = res.data.result || {}
          this.programList = res.data.result.records || []
        })
      },
      doSearch() {
        if(this.searchFm.name){
          this.page.param = {name:`%${this.searchFm.name}%`}
        }
        this.fetchData()
      },
      sliceIntro(row, column, val) {
        if(row.intro.length>50){
          return row.intro.substr(0,50) + '...'
        }else{
          return row.intro
        }
      },
      addProgram(val) { // 添加方案
        this.addDialog = true
        this.echoId = val
      },
      remove(val) {
        handleConfirm('此操作将永久删除, 是否继续?').then(() => {
          deleteProgram(val).then(resp => {
            this.$message.success(resp.data.message)
            this.fetchData()
          })
        })
      },
      saveFinish(flag = false) {
        this.addDialog = false
        if(flag){
          this.fetchData()
        }
      }
    }
  }
</script>
